import { getDayOfWeek } from '@teetsh/app/src/utils/time/getDayOfWeek';

export const getMonday = (hour, minutes) => getDayOfWeek(1, hour, minutes);
